module.exports = __webpack_public_path__ + "04_short_grey.b63a0a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_short_grey.png
// module id = xhsh
// module chunks = 0